<template>
  <div class="portada-xv" ref="rootRef" aria-label="XV Cover">
    <!-- DECORATIVE FLOWERS -->
    <img src="@/assets/flor1.png" class="flor flor-1" alt="" />
    <img src="@/assets/flor3.png" class="flor flor-2" alt="" />
    <img src="@/assets/flor3.png" class="flor flor-3" alt="" />

    <!-- NEW FLOWERS -->
    <img src="@/assets/flor1.png" class="flor flor-4" alt="" />
    <img src="@/assets/flor4.png" class="flor flor-5" alt="" />
    <img src="@/assets/flor3.png" class="flor flor-6" alt="" />

    <!-- ROTATING DISCO BALL -->
    <img src="@/assets/disco.png" class="bola bola-izquierda" alt="" />

    <!-- IMAGE WITH CROP -->
    <div class="imagen-xv-wrapper">
      <img src="@/assets/6G1A2554-1.webp" class="imagen-xv" alt="Main photo" />
    </div>

    <!-- MAIN TEXT -->
    <section class="texto-xv">
      <p class="frase-bendicion">
        With the blessing of God <br />
        and of my parents
      </p>

      <div class="separador-elegante" aria-hidden="true"></div>

      <h1 class="nombre-protagonista">Héctor Macedonio Francisco</h1>
      <h1 class="nombre-protagonista">Jennifer&nbsp; J Ortiz</h1>

      <p class="parrafo-presentacion">
        There are moments that define our lives, remaining engraved in the soul and in memory.
        Today I experience one of those special moments, and I wish to share it with those
        who hold a place in my heart.
      </p>
    </section>
  </div>
</template>

<script>
import { onMounted, ref, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'PortadaArley',
  setup() {
    const rootRef = ref(null)

    onMounted(async () => {
      await nextTick()

      const $ = (sel) => Array.from(gsap.utils.toArray(sel)).filter(Boolean)

      const foto = $('.imagen-xv-wrapper')
      const flores = [
        '.flor-1',
        '.flor-2',
        '.flor-3',
        '.flor-4',
        '.flor-5',
        '.flor-6'
      ].flatMap($)

      const texto = [
        '.frase-bendicion',
        '.separador-elegante',
        '.nombre-protagonista',
        '.parrafo-presentacion'
      ].flatMap($)

      gsap.set([...foto, ...flores, ...texto], { autoAlpha: 0, y: 28 })

      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'power2.out' } })

          tl.fromTo(
            foto,
            { scale: 0.94, y: 40, filter: 'blur(6px)' },
            { autoAlpha: 1, scale: 1, y: 0, filter: 'blur(0px)', duration: 1.15 }
          )

          tl.to(
            flores,
            {
              autoAlpha: 1,
              y: 0,
              rotate: () => gsap.utils.random(-8, 6),
              duration: 0.9,
              stagger: 0.12
            },
            '-=0.6'
          )

          tl.to(texto, { autoAlpha: 1, y: 0, duration: 0.8, stagger: 0.15 }, '-=0.3')

          // FLORES FLOTANTES (MAGIA ✨)
          flores.forEach((flor, i) => {
            gsap.to(flor, {
              y: `+=${gsap.utils.random(6, 14)}`,
              x: `+=${gsap.utils.random(-6, 6)}`,
rotation: gsap.utils.random(-0.8, 0.8),
              duration: gsap.utils.random(2.8, 4),
              repeat: -1,
              yoyo: true,
              ease: 'sine.inOut',
              delay: i * 0.2
            })
          })

          gsap.to(foto, {
            scale: 1.015,
            duration: 3.5,
            yoyo: true,
            repeat: -1,
            ease: 'sine.inOut'
          })

          io.disconnect()
        })
      }, { threshold: 0.45 })

      if (rootRef.value) io.observe(rootRef.value)
    })

    return { rootRef }
  }
}
</script>

<style scoped>
/* TODO TU CSS ORIGINAL SE MANTIENE */

.flor-4{
  top: 80px;
  left: 0px;
    transform: translateX(-50%) rotate(-12deg);

  width: min(40vw, 200px);
  z-index: 6;
}
.flor-5{
  bottom: 20px;
      transform: translateX(-50%) rotate(-12deg);
opacity: 0 !important;

  right: 0px;
  width: min(46vw, 240px);
  z-index: 8;
}
.flor-6{
  top: 420px;
    transform: translateX(-50%) rotate(-12deg);
  right: -150px;
  width: min(34vw, 180px) !important;
  z-index: 3;
}
</style>


<style scoped>
.portada-xv{
  position:relative;
  width:100%;
  min-height:100vh;
  background:#fff;
  overflow:visible;
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:flex-start;
  padding:48px 16px 56px;
}

/* Marco con recorte superior redondeado (look luxury) */
.imagen-xv-wrapper{
  width: min(92vw, 360px);
  height: calc(min(92vw, 360px) * 1.5);
  margin-top: 6px;
  border-radius: 180px 180px 0 0;
  overflow: hidden;
  z-index: 2;
  background:#fff;
  box-shadow:
    0 12px 40px rgba(0,0,0,.18),
    0 2px 8px rgba(0,0,0,.06);
  will-change: transform, filter, opacity;
}
.imagen-xv{
  width:100%;
  height:100%;
  object-fit:cover;
  display:block;
}

/* Texto */
.texto-xv{
  max-width: 620px;
  text-align:center;
  margin-top: 22px;
  padding: 0 8px;
}
.frase-bendicion{
  font-family: "Playfair Display", serif;
  font-size: clamp(18px, 2.6vw, 24px);
  color:#2f2e2e;
  line-height:1.5;
  margin: 20px 0 10px;
}
.separador-elegante{
  width:110px;
  height:2px;
  margin:12px auto 16px;
  background: linear-gradient(90deg, transparent, #d9b7c6, transparent);
  border-radius: 2px;
}
.nombre-protagonista{
  font-family: "titulos", cursive;
  font-size: 46px;
  color:#e6b1c4;
  margin: 0 0 8px 0;
  line-height:1.1;
}
.parrafo-presentacion{
  font-family: "quote", sans-serif;
  font-size: clamp(14px, 2.6vw, 16px);
  color:#3d3c3c;
  line-height:1.7;
  margin-top: 6px;
}

/* FLORES */
.flor{
  position:absolute;
  width:min(44vw, 240px);
  z-index:10;
  transform-origin:center;
  will-change: transform, opacity;
}
.flor-1{ top:-10px; left:-110px; z-index:5; }
.flor-2{ top:60px; right:-80px; transform: rotate(-80deg); z-index:1; width:min(40vw, 220px) !important;  }
.flor-3{ bottom:-80px; left:-120px; transform: rotate(-30deg); z-index:9;}

/* BOLA DISCO */
.bola{
  position:absolute;
  width:120px;
  animation: girar 10s linear infinite;
  opacity:.85;
  z-index:1;
  opacity:0 !important;
  will-change: transform;
}
.bola-izquierda{ left:-20px; bottom:-50px; z-index:9;}
@keyframes girar{ from{transform:rotate(0)} to{transform:rotate(360deg)} }

/* Responsive refinado */
@media (min-width: 992px){
  .portada-xv{ padding-top:64px; }
  .imagen-xv-wrapper{ margin-top: 0; }
}
</style>
